module.exports = __webpack_public_path__ + "img/SKMJ_car6.5b8a686e.jpg";